import { xmtpEnvelope as proto } from '@xmtp/proto';
import PublicKey from './PublicKey';
// PublicKeyBundle packages all the keys that a participant should advertise.
// The PreKey must be signed by the IdentityKey.
// The IdentityKey can be signed by the wallet to authenticate it.
export default class PublicKeyBundle {
    constructor(identityKey, preKey) {
        if (!identityKey) {
            throw new Error('missing identity key');
        }
        if (!preKey) {
            throw new Error('missing pre-key');
        }
        this.identityKey = identityKey;
        this.preKey = preKey;
    }
    walletSignatureAddress() {
        return this.identityKey.walletSignatureAddress();
    }
    toBytes() {
        return proto.PublicKeyBundle.encode(this).finish();
    }
    static fromBytes(bytes) {
        const decoded = proto.PublicKeyBundle.decode(bytes);
        if (!decoded.identityKey) {
            throw new Error('missing identity key');
        }
        if (!decoded.preKey) {
            throw new Error('missing pre-key');
        }
        return new PublicKeyBundle(new PublicKey(decoded.identityKey), new PublicKey(decoded.preKey));
    }
}
//# sourceMappingURL=PublicKeyBundle.js.map